module.exports = __webpack_public_path__ + "static/media/soccer-ball.15e832ef.svg";